import { forwardRef, HTMLAttributes, ReactElement, Ref } from 'react';

import { IComponent } from '../../models/components.models';
import { useClassNames } from '../../utils/hooks';
import { Breadcrumb, IBreadcrumbProps } from '../Breadcrumb/Breadcrumb';
import { IPageHeaderClassNames, IPageHeaderStyles, pageHeaderStylesDefault } from './PageHeader.styles';

export interface IPageHeaderProps extends IComponent<IPageHeaderStyles>, HTMLAttributes<HTMLDivElement> {
  pageTitle?: string | ReactElement;
  titleContents?: ReactElement;
  actions?: ReactElement;
  description?: string | ReactElement;
  breadcrumbProps?: IBreadcrumbProps;
  contents?: ReactElement;
  secondaryContents?: ReactElement;
  secondaryActions?: ReactElement;
  maxSearchWidth?: number;
}

export const PageHeader = forwardRef((props: IPageHeaderProps, ref: Ref<HTMLDivElement>) => {
  const {
    styles,
    className,
    pageTitle,
    titleContents,
    actions,
    description,
    breadcrumbProps,
    contents,
    secondaryContents,
    secondaryActions,
    ...elementProps
  } = props;
  const classNames = useClassNames<Partial<IPageHeaderStyles>, IPageHeaderClassNames>(
    'PageHeader',
    pageHeaderStylesDefault,
    styles,
    className
  );
  return (
    <div {...elementProps} ref={ref} className={classNames.root} data-test={props['data-test'] || 'page-header'}>
      <div className={classNames.header}>
        <div className={classNames.titleContainer}>
          <div className={classNames.title}>{pageTitle}</div>
          {titleContents && <div className={classNames.titleContents}>{titleContents}</div>}
          {actions && <div className={classNames.actions}>{actions}</div>}
        </div>
        {description && <div className={classNames.description}>{description}</div>}
        {breadcrumbProps && (
          <div className={classNames.breadcrumb}>
            <Breadcrumb {...breadcrumbProps} />
          </div>
        )}
      </div>
      {contents && <div className={classNames.contents}></div>}
      {(secondaryContents || secondaryActions) && (
        <div className={classNames.secondaryHeader}>
          <div className={classNames.secondaryContents}>{secondaryContents}</div>
          {secondaryActions && <div className={classNames.secondaryActions}>{secondaryActions}</div>}
        </div>
      )}
    </div>
  );
});
